var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('p',[_vm._v("部分案例仅供参考，以下排名不分先后顺序")]),_vm._v(" "),(_vm.list.length>0)?_c('case-list',{attrs:{"dataList":_vm.list}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }